const mutations = {
    updateRules(state, rulesData) {
        state.data = rulesData
    },
    changeLoading(state, val) {
        state.loading = val;
    },
    changeFormType(state, val) {
        if (val === "update") {
            state.isAddForm = false;
        } else {
            state.isAddForm = true;
        }
    },
    changeSelectedState(state, value) {
        state.selectedState = value;
    }
}

export default mutations;